module.exports = __webpack_public_path__ + "static/media/google.fafed290.png";